// @ts-nocheck
import { replaceAllNotDigitsTextCursor } from '../replaceWithCursorPosition';

export class MaskOnlyNumbers {
  constructor(_view: any, public assets: any) {}

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(value, cursorPosition);
    return { newValue, newCursorPosition };
  }

  public setMask(value: string, cursorPosition): { formatedValue; formatedCursorPosition } {
    try {
      const formatedValue = value.replace(/[^\d]/g, '');

      return { formatedValue, formatedCursorPosition: cursorPosition };
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    }
  }

  public getMaskErrors() {
    return [this.assets.labels.feedbacks.masks['ONLY_NUMBERS']];
  }
}
